import { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import EToolsThemeProvider from 'src/theme/e-tools-theme';
import { useResponsive } from 'src/hooks/use-responsive';

import EToolsNav from './nav';
import EToolsHeader from './header';
import { E_TOOLS_HEADER, E_TOOLS_NAV } from './config';

export default function EToolsLayout({ children }) {
  const [openNav, setOpenNav] = useState(false);
  const lgUp = useResponsive('up', 'lg');

  return (
    <EToolsThemeProvider>
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
        <EToolsHeader onOpenNav={() => setOpenNav(true)} />
        <EToolsNav openNav={openNav} onCloseNav={() => setOpenNav(false)} />

        <Box
          component="main"
          sx={{
            minHeight: '100vh',
            pt: `${E_TOOLS_HEADER.H_MOBILE + 16}px`,
            px: { xs: 2, md: 3 },
            pb: 4,
            ...(lgUp && {
              pt: `${E_TOOLS_HEADER.H_DESKTOP + 24}px`,
              ml: `${E_TOOLS_NAV.WIDTH}px`,
              px: 4,
            }),
          }}
        >
          {children}
        </Box>
      </Box>
    </EToolsThemeProvider>
  );
}

EToolsLayout.propTypes = {
  children: PropTypes.node,
};
